class trainingHelper {
    constructor() {

    }
    registerNewUser(el) {
        let form = $(el);
        let modal = $('#register-modal');
        let submitButton = $('#submitButton');
        let body = $('body');
        let message = $('#message');

        let forms = document.getElementsByClassName('needs-validation');
        // Loop over them and prevent submission
        let validation = Array.prototype.filter.call(forms, function (form_field) {
            form_field.addEventListener('submit', function (event) {
                if (form_field.checkValidity() === false) {
                    event.preventDefault();
                    event.stopPropagation();
                    $('html, body').animate({
                        scrollTop: $(form_field).offset().top - 200
                    }, 2000);
                } else {
                    event.preventDefault();
                    console.log(form);
                    form[0].classList.add('was-validated');

                    let valuesObj = {};
                    let valuesArray = $('#poll_worker_user_registration').serializeArray();

                    for (let i = 0; i < valuesArray.length; i++) {
                        valuesObj[valuesArray[i]['name']] = valuesArray[i]['value'];
                    }

                    modal.css('display', 'flex');
                    modal.addClass('in');
                    submitButton.attr("disabled", "disabled");
                    body.addClass('submitting-registration');

                    $.ajax({
                        type: "POST",
                        dataType: 'json',
                        url: '/wp-admin/admin-ajax.php',
                        data: {
                            action: 'poll_worker_registration',
                            value: valuesObj
                        },
                        success: function (response) {
                            console.log(response);
                            if (response.error == true) {
                                // response.field.forEach(element => {
                                //     $(element).addClass('is-invalid');
                                // });
                                // modal.removeClass('in');
                                // modal.css('display', 'none');
                                // submitButton.removeAttr("disabled");
                                // body.removeClass('submitting-registration');


                                //so errors
                                console.log('response errors');
                            } else {
                                //remove modal
                                setTimeout(function () {
                                    modal.removeClass('in');
                                    modal.css('display', 'none');
                                    submitButton.removeAttr("disabled");
                                    body.removeClass('submitting-registration');
                                    //hide form
                                    form.hide();
                                    //display success message
                                    message.append('<h2>' + response.message + '</h2>');
                                    console.log('response success');
                                }, 3000);
                            }
                        },
                    });
                }
            }, false);
        });

    }

}

window.app.add('training', new trainingHelper());